<template>
    <div>
        <Card>
            <div class="search-con search-con-top">
                <Form :model="form" :label-width="80" inline>
                    <FormItem label="话术标识">
                        <Input v-model="form.code"></Input>
                    </FormItem>
                </Form>
                <div  class="toolbar">
                    <Button type="primary" icon="md-add" @click="handleCreate">新增</Button>
                    <!-- <Button type="primary" icon="md-trash" @click="handleDelete">删除</Button> -->
                   <Button @click="handleSearch" icon="md-search" class="search-btn" type="primary">搜索 </Button>
                </div>
            </div>
            <Tables ref="tables" v-model="tableData" :columns="columns" @on-search="handleSearch"
                    @on-update="handleUpdate" @on-detail="handleDetail" @on-selection-change="selectionChange"/>
        </Card>
        <aiscriptInfo ref="aiscriptInfoRef"  @handle-search="handleSearch"></aiscriptInfo>
    </div>
</template>

<script>
import aiscriptInfo from './aiscript-info'
import { getIds } from '@/libs/util'

export default {
  name: 'aiscript-list',
  components: {
    aiscriptInfo
  },
  data () {
    return {
      columns: [
        // { title: '', key: 'id', type: 'selection', width: 60 },
        { title: '话术标识', key: 'code' },
        { title: '收支方向', key: 'type' },
        { title: '内容', key: 'content' },
        { title: '创建时间', key: 'crtTime' },
        { title: '修改人', key: 'mdfUserId' },
        { title: '修改时间', key: 'mdfTime' },
        {
          title: '操作',
          key: 'handle',
          minWidth: 200,
          options: ['update', 'detail']
        }
      ],
      tableData: {
        rows: [],
        total: 0
      },
      form: {
        map: {}
      },
      statusOptions: [
        { key: 0, name: '禁用' },
        { key: 1, name: '启用' }
      ],
      selectedData: [],
      infoIsShow: false
    }
  },
  methods: {
    handleUpdate (param) {
      this.$refs.aiscriptInfoRef.openModel('update', param.row)
    },
    handleDetail (param) {
      this.$refs.aiscriptInfoRef.openModel('detail', param.row)
    },
    handleCreate () {
      this.$refs.aiscriptInfoRef.openModel('create')
    },
    handleDelete () {
      this.D('aiscript', getIds(this.selectedData)).then(data => {
        this.$Message.success(data)
        this.handleSearch()
      })
    },
    selectionChange (selection) {
      this.selectedData = selection
    },
    getStatusVal (status) {
      return status === 0 ? '禁用' : '启用'
    },
    handleSearch (page, pageSize) {
      if (isNaN(page)) {
        page = 1
      }
      var param = {
        page: page,
        pageSize: pageSize,
        model: this.form,
        map: this.form.map
      }
      this.L('aiscript', param).then(data => {
        this.tableData = data
      })
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>
